import { render, staticRenderFns } from "./ModalCreatePopulation.vue?vue&type=template&id=63752414&scoped=true&"
import script from "./ModalCreatePopulation.vue?vue&type=script&lang=js&"
export * from "./ModalCreatePopulation.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreatePopulation.vue?vue&type=style&index=0&id=63752414&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63752414",
  null
  
)

export default component.exports